export const ACCU_WEATHER_API_KEY = 'kLEuedwDFjaE6J3WKD67IWlo1sGRGAZI';

export const ACCU_WEATHER_API_URL = 'https://dataservice.accuweather.com';